import React from 'react'
import { Badge, Button } from 'antd'
import { ShoppingCartOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import Routes from '../../constants/routes'
import cartSelectors from '../../store/selectors/cart.selectors'
import { useSelector } from 'react-redux'

const CartButton = () => {
    const cart = useSelector(cartSelectors.all)

    return cart?.length ? (
        <Badge className='badge-count-number' count={cart?.length}>
            <Link to={Routes.CART}>
                <Button type='text' shape='circle' size='large' icon={<ShoppingCartOutlined />} aria-label='cart' />
            </Link>
        </Badge>
    ) : null
}

export default CartButton
